import './application'
import '../utils/lightbox';
import { OnBoardingGoal } from '../utils/models/OnBoardingGoal';
import { POIUtility } from '../utils/models/POI';
import '../apps/comments/main';
import '../apps/on_boarding/main';
import '../apps/download_modal/main';
import '../utils/analytics/analytics';
import chromeImage from '../images/browser-icon-chrome.svg';
import safariImage from '../images/browser-icon-safari.svg';
import edgeImage from '../images/browser-icon-edge.svg';
import operaImage from '../images/browser-icon-opera.svg';
import firefoxImage from '../images/browser-icon-firefox.svg';
import defaultImage from '../images/browser-icon-default.svg';
import { RevenueCatWrapper } from '../utils/RevenueCatWrapper';
import '../apps/flyover_preview/main.ts';
import { openPrintMapFallback } from '../utils/printMaps';

declare global {
  interface Window {
    printingUrl?: string;
  }
}

const gpxDownloadButtons = document.querySelectorAll('.gpx-download');
const printMapsDownloadButtons = document.querySelectorAll('.print-map-download');
const addToTrailListButton = document.querySelector('.add-to-trail-list');

const amenityItemImage = document.getElementById('amenity_item_image');

if (amenityItemImage) {
  const amenityImage = POIUtility.fromString(window.popularAmenityType);
  // Set the background-image
  amenityItemImage.src = amenityImage.highlightImage();
}

const accomItemImage = document.getElementById('accom_item_image');

if (accomItemImage) {
  const accomImage = POIUtility.fromString(window.popularAccomType);
  // Set the background-image
  accomItemImage.src = accomImage.highlightImage();
}

if (gpxDownloadButtons) {
  gpxDownloadButtons.forEach((gpxDownloadButton) => {
    gpxDownloadButton.addEventListener('click', () => {
      window.openDownloadModal();
    });
  });
}

if (printMapsDownloadButtons) {
  printMapsDownloadButtons.forEach((printMapsDownloadButton) => {
    printMapsDownloadButton.addEventListener('click', async () => {
      const isProOrProPlus = await RevenueCatWrapper.isProOrProPlus();
      if (isProOrProPlus) {
        if (!openPrintMapFallback(window.printingUrl)) {
          console.warn('Print map URL unavailable for this hike.');
        }
        return;
      }

      window.location.href = '/pricing';
    });
  });
}

if (addToTrailListButton) {
  addToTrailListButton.addEventListener('click', () => {
    window.onBoardingVue.launchFor(OnBoardingGoal.AddTrailToList);
  });
}

$(() => $('.carousel.lazy').on('slide', (ev) => {
  let lazy;
  lazy = $(ev.relatedTarget).find('img[data-src]');
  lazy.attr('src', lazy.data('src'));
  lazy.removeAttr('data-src');
}));

function detectBrowser() {
  const { userAgent } = navigator;

  if (userAgent.includes('Chrome') && !userAgent.includes('Edge') && !userAgent.includes('OPR')) {
    return 'chrome';
  } if (userAgent.includes('Firefox')) {
    return 'firefox';
  } if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    return 'safari';
  } if (userAgent.includes('Edge')) {
    return 'edge';
  } if (userAgent.includes('OPR')) {
    return 'opera';
  }
  return 'default';
}

// Set browser icon based on detected browser
function setBrowserIcon() {
  const browser = detectBrowser();
  const browserIcon = document.getElementById('browserIcon');

  switch (browser) {
    case 'chrome':
      browserIcon.src = chromeImage;
      browserIcon.alt = 'Chrome Logo';
      break;
    case 'firefox':
      browserIcon.src = firefoxImage;
      browserIcon.alt = 'Firefox Logo';
      break;
    case 'safari':
      browserIcon.src = safariImage;
      browserIcon.alt = 'Safari Logo';
      break;
    case 'edge':
      browserIcon.src = edgeImage;
      browserIcon.alt = 'Edge Logo';
      break;
    case 'opera':
      browserIcon.src = operaImage;
      browserIcon.alt = 'Opera Logo';
      break;
    default:
      browserIcon.src = defaultImage;
      browserIcon.alt = 'Browser Logo';
  }
}

// Function to detect mobile devices
function isMobileDevice() {
  return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

$(document).ready(() => {
  if (isMobileDevice()) {
    showModalOnFirstVisit();
  }

  // Intercept map button clicks and show onboarding modal for non-logged-in users
  const mapLinks = document.querySelectorAll('a[href*="/map"]');
  mapLinks.forEach((mapLink) => {
    mapLink.addEventListener('click', (e) => {
      // If user is logged in, let them continue to the map
      if (window.user) {
        return; // Allow default behavior
      }
      
      // Otherwise, prevent navigation and show onboarding modal
      e.preventDefault();
      
      // Store the intended destination in sessionStorage for redirect after login
      const mapUrl = (e.currentTarget as HTMLAnchorElement).href;
      sessionStorage.setItem('redirectAfterLogin', mapUrl);
      
      window.onBoardingVue.launchFor(OnBoardingGoal.TrailMap);
    });
  });
});
